export default "__VITE_ASSET__BJj_Qtye__"